import React, { useState } from "react";
import { Image } from "grommet";
import Popover from "react-popover";

import noEmailAddressImage from "../../images/no-email-address.svg";

export default function NoPhoneIcon(props) {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      key={props.pkey}
      isOpen={open}
      body="This guest has no email address on file."
      children={
        <div
          key={props.pkey}
          onMouseOver={() => setOpen(true)}
          onMouseOut={() => setOpen(false)}
        >
          <Image style={{ width: "16px" }} src={noEmailAddressImage} />
        </div>
      }
    />
  );
}
